import React, { Component } from "react";
import { connect } from 'react-redux';
import {setUsers, setReferral} from '../_actions/user';
import { TextField, Button } from "@material-ui/core";
import ReactGA from 'react-ga';
import {GAevent} from './TrackingEvent'
import axios from 'axios'
import {API} from '../_redux/helper'
import ReactPixel from 'react-facebook-pixel';
import Policy from "./Policy";
import Terms from "./Terms";
import closemodal from "../images/closemodal.png";
import Modal from "react-awesome-modal";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import CryptoJS from 'crypto-js';
var key = CryptoJS.enc.Utf8.parse("68D83A2CCC84F2A8B7ADB64B38B86576")
var iv = CryptoJS.enc.Utf8.parse("116C893F5CF1AA0AFAABBF28C32CFBE2")       
var $ = require("jquery");

class Register1 extends Component {
  constructor(props) {
    super(props);
    this.state ={
        fields: {
            email: "",
            password: "",
            name:"",
            phone_number:"",
            message: '',
          },
        refer_code: '',
        login: false,
        show:false,
        errors: {},
        disabled : false,
        terms:false,
        policy:false,
        vr_txt:false,
        status_name:true,
        status_email:true,
        status_password:true,
     }
  }
  componentDidMount(){
    if(window.location.search) {
       /* eslint eqeqeq: 0 */
      if(window.location.search.indexOf('refer_code') != -1) {
        let splitedUrl = window.location.search.split('=')[1]
        axios
          .get(`${API}/api/getdata_referfriend/${splitedUrl}`)
          .then((res) => {
            this.setState({ refer_code: splitedUrl })
            this.setState({ fields: { email: res.data[0].email } })
            this.setState({ disabled: true })
          })
          .catch((err) => {

          })
      }
    }
    const loc = window.location.pathname
    const loc_2 = "/personality-profiler-stand-alone"
    const _name = sessionStorage.getItem("s-name")
    const _email = sessionStorage.getItem("s-email")
    if (loc.toLowerCase()===loc_2){
      this.setState({ fields: { email: _email, name:_name } })
    }
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleValidation(){
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    let _name 

    if(!fields["name"]){
       formIsValid = false;
       errors["name"] = "Name cannot be empty";
    }

    if(typeof fields["name"] !== "undefined" && !fields["name"] === false){
       if(!fields["name"].match(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/)){
          formIsValid = false;
          errors["name"] = "Please fill with alphabets only";
       }
    }

    if(!fields["email"]){
       formIsValid = false;
       errors["email"] = "Email cannot be empty";
    }

    if(typeof fields["email"] !== "undefined" && !fields["email"] === false){
       let lastAtPos = fields["email"].lastIndexOf('@');
       let lastDotPos = fields["email"].lastIndexOf('.');

       if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
          formIsValid = false;
          errors["email"] = "Invalid email";
        }
   }

    if(fields["password"]==="" || fields["password"]===undefined){
      formIsValid = false;
      errors["password"] = "Password cannot be empty";
    } else {
      let tmp = fields["password"].split('')
      let num = 0;
      
      const forbiddenChara = ['[', ']', `"`, "'", "`", '\\', '-', '_', ';', ':', '=']
      for (let i = 0; i < forbiddenChara.length; i++) {
        if (tmp.includes(forbiddenChara[i])) {
          num++
        }
      }

      if (num > 0) {
        formIsValid = false;
        errors["password"] = "Password contains forbidden characters";
      } else {
        const passwordLength = /^(?=.*[\d]{1,})(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[~!@#$/€£¥%&^|+*)(}{><.,?})]).{8,16}$/;
        if(!fields["password"].match(passwordLength) || num > 0){
          formIsValid = false;
          errors["password"] = "Password must be at least 8 characters contains a capital letter, a symbol, and a number";
        }}
    }
      

   this.setState({errors: errors});
   return formIsValid;
}

handleChange(field, e){
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({fields});
}

  onChangeEmail = event => {
    this.setState({ email: event.target.value });
  };
  onChangeName = event => {
    this.setState({ name: event.target.value });
  };
  onChangePhone = event => {
    this.setState({ phone_number: event.target.value });
  };
  onChangePassword = event => {
    this.setState({ password: event.target.value });
  };

   register = (e) => {
    e.preventDefault();
    if(this.handleValidation()){
        let user = {
            name: this.state.fields["name"],
            password: this.state.fields["password"],
            email: this.state.fields["email"],
            phone_number: this.state.fields["phone_number"],
            refer_code: this.state.refer_code
        };
        user["name"] = CryptoJS.TripleDES.encrypt(user["name"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        user["email"] = CryptoJS.TripleDES.encrypt(user["email"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        user["password"] = CryptoJS.TripleDES.encrypt(user["password"], key, { iv: iv, mode: CryptoJS.mode.CBC}).toString()
        
        this.props.signUp1(user)
    }else{
    }
      GAevent('Register','Submit (Register)') 
      ReactPixel.track('Register','Submit (Register)'); 
  };


  updateNumber = (e) => {
    const val = e.target.value;
    if (e.target.validity.valid) this.setState({message: e.target.value});
    else if (val === '' || val === '-') this.setState({message: val});
  }
  showPassword=(e)=>{
    this.setState({show:!this.state.show})
  }

  
  changeTnC=(e)=>{
  if (e==="terms"){
    this.setState({terms: !this.state.terms})
  }else{
    this.setState({policy:!this.state.policy})
  }
  this.props.parentCallback(e);
  $('#set-TnC').css("margin-top","103px");
  $('#pop-TnC').css("margin-top","-120px");
  }

  closeTnC=()=>{
    this.setState({terms:false,policy:false})
    this.props.parentCallback("");
    $('#set-TnC').css("margin-top","-100px");
    $('#pop-TnC').css("margin-top","123px");
  }

  

  render() {
    const {show, fields, errors, vr_txt, status_email,status_name,status_password}= this.state
    const loc = window.location.pathname
    const loc_2 = "/personality-profiler-stand-alone"
    const _name = sessionStorage.getItem("s-name")
    const _email = sessionStorage.getItem("s-email")
    let s_name
    let s_email
    if (_name != undefined && _email!= undefined){
      s_name = _name
      s_email = _email
    }else{
      s_name = ""
      s_email =""
    }
 

    return (
      <div>
        <div className="login">
         <form onSubmit={this.register} id="register">
            <div>
              <h4>
              Sign up
              </h4>
              <p>Make sure you fill out your information correctly</p>
              <div className="box-signup">
                  <TextField  label="Full Name" variant="outlined" type="text" className="form-control" name="name" id="name" disabled={loc.toLowerCase()===loc_2?true:false}
                     style={{width:"100%"}} pattern="[A-Za-z- ]{3,30}" minLength="4" required=""  
                    refs="name" onChange={this.handleChange.bind(this, "name")} value={loc.toLowerCase()===loc_2?s_name: this.state.fields["name"]}/>
                     <span className="err-ntf" style={{color: "red", fontSize:"12px"}}>{this.state.errors["name"]}</span>
              </div>
              <div className="box-signup">
                  <TextField  label="Email" variant="outlined" type="email" className="form-control" name="email" id="email" 
                     style={{width:"100%"}} required="" disabled={loc.toLowerCase()===loc_2?true:this.state.disabled} 
                    refs="email" aria-describedby="emailHelp" onChange={this.handleChange.bind(this, "email")} value={loc.toLowerCase()===loc_2?s_email: this.state.fields["email"]}/>
                     <span className="err-ntf" style={{color: "red", fontSize:"12px"}}>{this.state.errors["email"]}</span>
              </div>
              <div className={this.state.errors["password"] === undefined?"box-signup show-pass":"box-signup wo show-pass"}>
                  <TextField  label="Password" className="form-control"  variant="outlined"  type={show?"text":"password"} name="password" id="password" 
                    style={{width:"100%"}} minLength="8" required=""  
                    refs="password" onChange={this.handleChange.bind(this, "password")} value={this.state.fields["password"]}/>
                    
                     {show===true &&
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(false)}>
                   <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                   </svg>
                   }
                    {show===false &&
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>this.showPassword(false)}>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29077 8.2301C6.1648 6.67673 8.89044 5 12 5C15.1096 5 17.8352 6.67673 19.7092 8.2301C20.6604 9.01854 21.4277 9.8047 21.9576 10.3937C22.2231 10.6888 22.4305 10.9362 22.5732 11.1119C22.6445 11.1997 22.6998 11.2698 22.7381 11.3191C22.7572 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7572 12.6562 22.7381 12.6809C22.6998 12.7302 22.6445 12.8003 22.5732 12.8881C22.4305 13.0638 22.2231 13.3112 21.9576 13.6063C21.4277 14.1953 20.6604 14.9815 19.7092 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89044 19 6.1648 17.3233 4.29077 15.7699C3.33956 14.9815 2.57228 14.1953 2.04241 13.6063C1.77689 13.3112 1.56947 13.0638 1.42684 12.8881C1.35548 12.8003 1.30024 12.7302 1.26193 12.6809C1.24277 12.6562 1.22785 12.6367 1.21725 12.6228L1.20461 12.6061L1.20075 12.601L1.19944 12.5992C1.19923 12.599 1.19854 12.598 2 12C1.19854 11.402 1.19873 11.4017 1.19893 11.4014L1.20075 11.399L1.20461 11.3939L1.21725 11.3772C1.22785 11.3633 1.24277 11.3438 1.26193 11.3191C1.30024 11.2698 1.35548 11.1997 1.42684 11.1119C1.56947 10.9362 1.77689 10.6888 2.04241 10.3937C2.57228 9.8047 3.33956 9.01854 4.29077 8.2301ZM2 12L1.19893 11.4014C0.934218 11.7562 0.933821 12.2433 1.19854 12.598L2 12ZM3.29219 12C3.36395 12.083 3.44309 12.1729 3.52929 12.2687C4.01148 12.8047 4.70865 13.5185 5.5671 14.2301C7.31235 15.6767 9.58671 17 12 17C14.4133 17 16.6877 15.6767 18.4329 14.2301C19.2913 13.5185 19.9885 12.8047 20.4707 12.2687C20.5569 12.1729 20.636 12.083 20.7078 12C20.636 11.917 20.5569 11.8271 20.4707 11.7313C19.9885 11.1953 19.2913 10.4815 18.4329 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58671 7 7.31235 8.32327 5.5671 9.7699C4.70865 10.4815 4.01148 11.1953 3.52929 11.7313C3.44309 11.8271 3.36395 11.917 3.29219 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5Z" fill="#292929"/>
                      <line x1="19.7231" y1="4.29703" x2="3.96037" y2="20.0598" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    }
                     <span className="err-ntf" style={{color: "red", fontSize:"12px"}}>{this.state.errors["password"]}</span>
              </div>
              
              <div>
                <div id="termsPolicy">
                  <p>By clicking Sign Up, you agree with Karya Talents' <a onClick={() => this.changeTnC("policy")}>
                      Privacy Policy</a> and <a onClick={() => this.changeTnC("terms")}>Terms of Service</a>
                  </p>
                </div>
                <Button id="button" variant="outlined" type="submit" className="_reg su-"
                  style={{ marginTop: "9px" ,backgroundColor:"#3B6C98",color:'white',width:'100%'}} >
                  Sign up
                </Button>
              </div>
            </div>
          </form>
        </div>
        <Modal
          id="terms"
          visible={this.state.terms}
          effect="fadeInUp" 
          onClickAway={ ()=>console.log("masuk")}
        >
          <div className="flex column popup-TnC" id="pop-TnC" >
          <div id="modal-header" className="modal-header-sign">
            <a href="javascript:void(0);" onClick={() => this.closeTnC()}>
              <LazyLoadImage effect="blur" loading="lazy" alt="" src={closemodal} />
            </a>
          </div>
          <Terms  />
          </div>
        </Modal>
        <Modal
         id="term"
          visible={this.state.policy}
          effect="fadeInUp"
          onClickAway={() => "hh"}
        >
          <div className="flex column popup-TnC"  id="pop-TnC" >
          <div id="modal-header" className="modal-header-sign">
            <a href="javascript:void(0);" onClick={() => this.closeTnC()}>
              <LazyLoadImage effect="blur" loading="lazy" alt="" src={closemodal} />
            </a>
          </div>
          <Policy />
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.signUp
  };
};

const mapDispatchToProps = dispatch => {
    return {
      signUp1: (event) => {
        if(event.refer_code) {
          dispatch(setReferral(event));
        } else {
          dispatch(setUsers(event));
        }
      }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Register1);
